import React from 'react';
import { motion } from 'framer-motion';
import { StatementSlide as StatementSlideType } from '../../types';
import { SlideContainer, SlideTitle, SlideSubtitle } from '../common/SlideComponents';

interface StatementSlideProps {
  content: StatementSlideType;
  speakerNotes?: string;
}

export const StatementSlide: React.FC<StatementSlideProps> = ({
  content,
  speakerNotes
}) => {
  return (
    <SlideContainer>
      <div className="flex flex-col justify-center items-center min-h-full text-center">
        <SlideTitle className="text-balance max-w-6xl">
          {content.mainStatement}
        </SlideTitle>
        
        {content.supportingText && (
          <SlideSubtitle className="mt-8 text-balance max-w-4xl">
            {content.supportingText}
          </SlideSubtitle>
        )}
      </div>
      
      {speakerNotes && (
        <div className="absolute bottom-4 left-4 opacity-0 hover:opacity-100 transition-opacity duration-200">
          <div className="bg-white/90 backdrop-blur-sm rounded-lg p-3 text-sm text-warm-gray max-w-xs">
            <strong>Speaker Notes:</strong> {speakerNotes}
          </div>
        </div>
      )}
    </SlideContainer>
  );
};